export class DateConsts {
    static readonly defaultMinYear = 1900;
    static readonly defaultMaxYear = 2100;
}
